<select [ngClass]="className" (change)="selectState($event.target.value)">
  @for (state of states; track state) {
    <option [value]="state.state" [selected]="state.state == initialState">
      {{ state.state_name }}
    </option>
  }
</select>
@if (showError && className === 'purchase-state-select') {
  <p class="help is-danger"
  [ngStyle]="{'justify-content': 'center'}">Please choose state where the property is located in.</p>
}